import React, { useEffect } from 'react'
import { Grid, Container, makeStyles } from '@material-ui/core'
import { useSearchParam } from '../../../../../hooks/useSearchParam'
import { useSchwabExchange } from './hooks'

const useStyles = makeStyles({
  formContainer: {
    display: 'flex',
    border: '1px solid black',
    borderRadius: '3px',
    padding: '2rem',
    justifyContent: 'center',
    alignContent: 'center'
  },
  headerText: {
    fontSize: '2rem',
    textAlign: 'center'
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    '& .__button': {
      borderRadius: '2rem',
      border: '1.5px solid #212945',
      backgroundColor: '#FFF',
      textTransform: 'none',
      padding: '0.5rem 1rem',
      maxHeight: '2.5rem'
    }
  }
})

const Callback = (props) => {
  const code = useSearchParam('code')
  const state = useSearchParam('state')

  const classes = useStyles()
  const { handleExchange } = useSchwabExchange(code, state)

  useEffect(() => {
    handleExchange()
  }, [handleExchange])
  return (
    <Container maxWidth='md' style={{ paddingTop: '1rem' }}>
      <div className={classes.formContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <h3 className={classes.headerText}>Successfully Authenticated!</h3>
          </Grid>
        </Grid>
      </div>
    </Container>
  )
}

export default Callback
